import { ReactNode } from 'react';
import { getPageMeta } from '@/routes-utils/get-page-meta.ts';
import { paths } from '@/routes-utils/paths.ts';
import { LoginComponent } from '../_auth.auth.login/login-component.tsx';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap.ts';
import { EnterpriseBrand } from './enterprise-brand.tsx';

export const handle: SeoHandle & { brandContent: () => ReactNode } = {
  sitemap: true,
  brandContent: () => <EnterpriseBrand />,
};

export const meta = () =>
  getPageMeta({
    url: 'https://synoptic.com/enterprise/login',
  });

export const action = () => new Response(null, { status: 405 });

export default function AuthEnterpriseLogin() {
  return <LoginComponent navigateTo={paths.enterprise} />;
}
